<div class="ui-g-12" *ngIf="this.packagesData.country != 'India'; else indianpackages">
  <p-tabView [(activeIndex)]="this.packagesData.tabview_Data.selected_tab">
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Package Form" leftIcon="pi pi-pencil">
      <div class="ui-g-12 text-center" *ngIf="this.packagesData.packages.length == 0">
        <p class="heading3">No packages available for this region.</p>
      </div>
      <div class="ui-g">
        <ng-container *ngIf="
            !this.packagesData.packages_list_api_result.Posting &&
            this.packagesData.packages_list_api_result.PromiseResult.success
          ">
          <ng-container *ngIf="
              this.packagesData.package_status != null &&
              this.packagesData.package_status.length > 0
            ">
            <div class="ui-g-12">
              <div class="ui-g">
                <div class="card two-d-card mr-auto ml-auto mt-5 ui-g-12" style="padding-left: 10px">
                  <div class="card-body heading4">
                    <div class="ui-g-12" style="display: flex">
                      <!-- <div class="ui-g-12 ui-lg-6"> -->
                      <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-3">
                          <p class="heading3">
                            <b> Subscription Status: </b>
                          </p>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                          <ng-container *ngFor="
                              let status of this.packagesData.package_status
                            ">
                            <div *ngIf="status.user_package_count.length">
                              <p class="heading3 egd-color">
                                {{ status.package_type.package_name }} Package
                                subscribed.
                              </p>
                              <p class="alert alert-success" *ngFor="
                                  let package_count of status.user_package_count
                                ">
                                {{ package_count.current_count }}
                                {{
                                package_count.consultation_type
                                .consultation_name
                                }}
                                consultations left.
                              </p>
                              <div class="">
                                Valid Till-{{ status.expiry_date }}
                                <span *ngIf="status.has_extended">(Extended)</span>
                              </div>
                              <br />
                            </div>
                          </ng-container>
                        </div>
                        <!-- </div> -->
                        <div class="ui-g-12 ui-lg-3 text-center">
                          <p-button type="button" [style]="{
                              'margin-right': '5px',
                              display: 'flex',
                              'align-items': 'center',
                              'justify-content': 'center'
                            }" styleClass=" ui-button-rounded heading4" label="Consult Doctor"
                            (click)="RouterNavigation('consultdoctor')" [disabled]="isPosting()">
                          </p-button>
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <p>
                        <b> Disclaimer: </b>
                      </p>
                      <p>
                        In case the package is not used in 6 months you can
                        email us at
                        <a href="mailto:support@eglobaldoctors.com" target="_blank">support@eglobaldoctors.com</a>
                        to extend your package for next one year.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="this.packagesData.packages.length > 0">
            <div style="text-align: center" class="ui-g-12">
              <p style="color: #004aad; font-size: xx-large; font-weight: bolder">
                Worried about your medical needs <span *ngIf="!this.is_uk_country">in USA</span>?
              </p>
              <p style="color: #004aad; font-size: xx-large; font-weight: bolder">
                Checkout Our Health Packages
              </p>
            </div>
            <form class="ui-g-12" accept-charset="UTF-8" #packageform="ngForm" (submit)="this.nextTab()">
              <div class="card-deck mt-5 ui-g-12">
                <div class="ui-g" style="display: flex; justify-content: center">
                  <div *ngFor="let package of this.packagesData.packages" class="ui-g-12 ui-md-6 ui-lg-4">
                    <div class="card packages-card" [style]="'background-color:' + package.color_code"
                      (click)="selectPackage(package.id)">
                      <div class="card-body">
                        <div class="ui-g">
                          <div class="ui-g-6">
                            <img [src]="package.image_web" />
                          </div>
                          <div class="ui-g-6 text-right">
                            <img class="pkgpricingimg" [src]="package.price_image" />
                          </div>
                        </div>
                        <div class="ui-g">
                          <div class="ui-g-12">
                            <h5 class="margin-0 package-name card-title font-weight-bolder heading2">
                              {{ package.package_name }}
                            </h5>
                            <div class="card-text">
                              <ul class="heading4">
                                <li class="card-li-txt" *ngFor="let desc of package.description">
                                  {{ desc }}
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="ui-g-12 text-center">
                            <p-button pRipple type="button" [styleClass]="
                                this.isCurrentPackageSelected(package.id)
                                  ? 'ui-button-success ui-button-rounded'
                                  : 'ui-button-rounded'
                              " [icon]="
                                this.isCurrentPackageSelected(package.id)
                                  ? 'pi pi-check'
                                  : 'pi pi-plus'
                              " [label]="
                                this.isCurrentPackageSelected(package.id)
                                  ? 'SELECTED'
                                  : 'SELECT'
                              " (click)="selectPackage(package.id)">
                            </p-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ui-g-12 text-center">
                <p-button type="submit" [style]="{ 'margin-right': '5px' }" label="Continue to Payment"
                  styleClass="heading4 p-button-lg ui-button-rounded" [disabled]="!packageform.valid || isPosting()">
                </p-button>
              </div>
              <div class="ui-g-12 text-center">
                <app-loading type="SMALL_LOADER" *ngIf="isPosting()"></app-loading>
              </div>
            </form>
            <div class="ui-g-12">
              <div class="card two-d-card mr-auto ml-auto mt-5">
                <div class="card-body">
                  <h5 class="card-title egd-color font-weight-bolder ml-1 heading2" style="margin: 10px">
                    Features
                  </h5>

                  <div class="card-text">
                    <ul class="font-weight-bold">
                      <li class="card-li-txt heading5">
                        <span *ngIf="this.is_uk_country">Access to GMC registered UK specialist doctors.</span><span *ngIf="!this.is_uk_country">Access to doctors from USA, UK, India and other parts of
                          the world</span>
                        <a class="egd-color show_click" target="viewAllDoctors" (click)="
                            openLink(
                              'HOMPAGE_BASE_URL',
                              'view-doctors',
                              'eGlobalDoctors-View-All-Doctors'
                            )
                          ">
                          <span *ngIf="this.is_primary_provider">(View Doctors)</span>
                        </a>
                        <i class="fa fa-arrow-left arrowfeatures heading3 alert alert-danger" aria-hidden="true"></i>
                      </li>
                      <li class="card-li-txt heading5">
                        Our Specialties - Internal Medicine, Cardiology,
                        Orthopedics, Oncology, Pediatrics, Psychiatry and many
                        more.
                        <a class="egd-color show_click" target="viewAllSpecialties" (click)="
                            openLink(
                              'HOMPAGE_BASE_URL',
                              'view-specialties',
                              'eGlobalDoctors-View-All-specialties'
                            )
                          ">
                          <span *ngIf="this.is_primary_provider">(View Specialties)</span>
                        </a>
                        <i class="fa fa-arrow-left arrowfeatures heading3 alert alert-danger" aria-hidden="true"></i>
                      </li>
                      <li class="card-li-txt heading5">
                        Prescription will be provided.
                      </li>
                      <li class="card-li-txt heading5">
                        Response time 1 - 3 days.
                      </li>

                      <li class="card-li-txt heading5">
                        Family Members can participate live via Video Physician
                        Consultation from any part of the world.
                      </li>
                      <li class="card-li-txt heading5">
                        Video Consultation upto 30 minutes.
                      </li>

                      <li class="card-li-txt heading5">
                        No restrictions on pre existing medical conditions.
                      </li>
                      <li class="card-li-txt heading5">
                        In-app messaging with doctor after consultation.
                      </li>
                      <li class="card-li-txt heading5">
                        ID and Portable Health Passports.
                      </li>
                      <li class="card-li-txt heading5">
                        These packages are applicable only for Primary
                        Consultations and <span *ngIf="!this.is_uk_country">Expert Second Medical Opinion.</span><span *ngIf="this.is_uk_country">Specialist Consultation.</span>
                      </li>
                      <li class="card-li-txt heading5">
                        Package subscription can be extended; it cannot be
                        canceled.
                      </li>
                      <li class="card-li-txt heading5">
                        If the subscribed package is not used in 6 months from
                        the date of purchase; subscription can be extended to
                        one year.
                      </li>
                      <li class="card-li-txt heading5">
                        The numbers are subject to change under the authority of
                        eGlobalDoctors.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="ui-g-12">
          <app-error-messages [api_result]="this.packagesData.packages_list_api_result">
          </app-error-messages>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Payment" leftIcon="pi pi-pencil">
      <div class="ui-g">
        <p class="heading2 egd-theme-text">Payment</p>
        <app-payment class="ui-g-12" [payment_data]="this.packagesData.paymentData"
          (payment_success)="onPaymentSuccess($event)"></app-payment>
        <div class="ui-g-12 text-align-right" *ngIf="!isPosting()">
          <p-button type="button" [style]="{ 'margin-right': '5px' }" (click)="prevTab()" label="Back"
            class="p-button-lg" icon="pi pi-arrow-left">
          </p-button>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Transaction Successful" leftIcon="pi pi-pencil">
      <p-dialog *ngIf="this.packagesData.print_data.displayModal" header="Invoice"
        [(visible)]="this.packagesData.print_data.displayModal" [modal]="true" [style]="{ width: '50vw' }">
        <div class="ui-g-12">
          <app-loading type="LOADING_DATA" *ngIf="this.packagesData.print_data.api_result.Posting">
          </app-loading>
        </div>
        <ng-container *ngIf="
            !this.packagesData.print_data.api_result.Posting &&
            this.packagesData.print_data.api_result.PromiseResult.success !=
              null &&
            this.packagesData.print_data.api_result.PromiseResult.success
          ">
          <div class="ui-g-12">
            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text">
            </p-button>
          </div>
          <div *ngIf="
              this.packagesData.print_data.api_result.PromiseResult.success !=
                null &&
              this.packagesData.print_data.api_result.PromiseResult.success
            ">
            <div class="spaces"></div>
            <app-invoicedetails class="notranslate" [data]="this.packagesData.print_data.data"
              [dataId]="this.packagesData.print_data.showInvoice">
            </app-invoicedetails>
          </div>
        </ng-container>
      </p-dialog>
      <div *ngIf="
          this.packagesData.print_data.api_result.PromiseResult.success !=
            null &&
          this.packagesData.print_data.api_result.PromiseResult.success
        ">
        <div class="spaces"></div>

        <app-invoicedetails class="notranslate" [data]="this.packagesData.print_data.data"
          [dataId]="this.packagesData.print_data.printContent">
        </app-invoicedetails>
      </div>
      <div class="ui-g text-center">
        <div class="ui-g-12">
          <img src="assets/images/thank-you/successful.gif" alt="" class="successful-logo" />
        </div>
        <div class="ui-g-12">
          <h2 class="egd-theme-text">Thank you for purchasing the package</h2>
        </div>
        <div class="ui-g-12">Transaction Successful</div>

        <div class="ui-g-12 transaction-success-buttons">
          <button pButton type="button" class="button-size" style="margin-right: 5px" label="Consult Doctor"
            (click)="RouterNavigation('consultdoctor')"></button>
          <button pButton class="button-size" type="button" style="margin-right: 5px" label="Navigate to Transactions"
            (click)="RouterNavigation('transactions')"></button>
          <!-- <p-button
            type="button"
            [style]="{ 'margin-right': '5px' }"
            label="Print Invoice"
            icon="pi pi-print"
            (click)="openInvoice()"
          >
          </p-button> -->
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
  <div class="ui-g-12">
    <app-loading type="LOADING_DATA" *ngIf="isPosting()"></app-loading>
  </div>
</div>
<ng-template #indianpackages>
  <app-membership-plan></app-membership-plan>
</ng-template>